import { BaseFiltroPagDTO } from "./base-dto";

export class ItemAgendaParmDTO {
  id: number;
  idTipo: number;
  titulo: string;
  descricaoLocal: string;
  presencial: boolean;
  dataIni: string;
  dataFim: string;
  horaIni: string;
  horaFim: string;
  dias: boolean;
  idsParticipantes: number[];
  observacao: string;
}

export class ItemAgendaFiltroDTO extends BaseFiltroPagDTO {
  idsTipos: number[];
  idsParticipantes: number[];
  dataIni: string;
  dataFim: string;
  titulo: string;
}